import {
  BREAKPOINT_ID_XXL,
  BREAKPOINT_ID_XL,
  BREAKPOINT_ID_LARGE,
  BREAKPOINT_ID_MAIN,
  BREAKPOINT_ID_MEDIUM,
  BREAKPOINT_ID_SMALL,
  BREAKPOINT_ID_TINY,
} from '@packages/systems/style/breakpoint-ids';
import type {BreakpointsConfig} from '@packages/systems/style/types';

export {getBreakpointLabel, getBreakpointWording} from './breakpoint-wording';

/*
 * Data used to store breakpoints in the backend.
 */

export const DEFAULT_BREAKPOINTS_CONFIG: BreakpointsConfig = {
  [BREAKPOINT_ID_MAIN]: {
    maxWidth: 10000,
  },
  [BREAKPOINT_ID_MEDIUM]: {
    maxWidth: 991,
  },
  [BREAKPOINT_ID_SMALL]: {
    maxWidth: 767,
  },
  [BREAKPOINT_ID_TINY]: {
    maxWidth: 479,
  },
};

export const LARGER_BREAKPOINTS_CONFIG: BreakpointsConfig = {
  [BREAKPOINT_ID_MAIN]: {
    maxWidth: 10000,
  },
  [BREAKPOINT_ID_XXL]: {
    minWidth: 1920,
  },
  [BREAKPOINT_ID_XL]: {
    minWidth: 1440,
  },
  [BREAKPOINT_ID_LARGE]: {
    minWidth: 1280,
  },
  [BREAKPOINT_ID_MEDIUM]: {
    maxWidth: 991,
  },
  [BREAKPOINT_ID_SMALL]: {
    maxWidth: 767,
  },
  [BREAKPOINT_ID_TINY]: {
    maxWidth: 479,
  },
};

/**
 * Resolve breakpoints when hydrating designer / multiplayer style state.
 *
 * Breakpoints are site-wide, but on a page branch they are split across two
 * documents: `baseStyles` carries the site-wide set (including any larger
 * breakpoints) while the branch's own working styles are seeded with
 * `DEFAULT_BREAKPOINTS_CONFIG`. Reading only one of them drops breakpoints, so
 * take the union — the same way swatches and macros are combined across both
 * documents on site load. Widths are fixed per breakpoint id and there is no UI
 * to edit them, so an id present in both documents always carries the same
 * value and the merge order is immaterial.
 */
export function resolveBreakpointsConfig(
  stylesBreakpoints?: BreakpointsConfig | null,
  baseStylesBreakpoints?: BreakpointsConfig | null
): BreakpointsConfig {
  const merged = {...baseStylesBreakpoints, ...stylesBreakpoints};
  return Object.keys(merged).length > 0 ? merged : DEFAULT_BREAKPOINTS_CONFIG;
}
